$bog_gamengine_demo_flat $mol_page
	title \Плоский мир
	tools /
		<= Coins $mol_labeler
			title \Монеты
			content / <= coins_stat \
		<= Screen_switch $mol_check_box
			title \Кнопки
			checked? <=> screen_shown? false
	body /
		<= Draw $bog_gamengine_draw
			scene <= Scene
			cam <= Cam
			stat => stat
			width => draw_width
			height => draw_height
			dpr => draw_dpr
			event *
				pointerdown? <=> pointer_down? null
		<= Hero_label $mol_view
			sub / \Герой
			style *
				left <= label_left \0px
				top <= label_top \0px
		<= Screen $bog_gamengine_input_screen
			shown? <=> screen_shown? false
	foot /
		<= Stat $mol_view
			sub / <= stat
		<= Hero_stat $mol_view
			sub / <= hero_stat \
		<= Ghost_stat $mol_view
			sub / <= ghost_stat \
		<= Nodes_stat $mol_view
			sub / <= nodes_stat \
	Input $bog_gamengine_input
		key <= Key
		screen <= Screen
	Key $bog_gamengine_key
		bind *
			left /
				\A
				\left
			right /
				\D
				\right
			up /
				\W
				\up
			down /
				\S
				\down
	map \
		\####################
		\#..................#
		\#..####............#
		\#..#...............#
		\#..#....######.....#
		\#..#.........#.....#
		\#............#.....#
		\#......###...#.....#
		\#............#.....#
		\#.....#............#
		\#.....#............#
		\#.....#.....####...#
		\#..................#
		\#..................#
		\####################
	Tile $bog_gamengine_phys_tile
		map <= map
	Atlas $bog_gamengine_atlas
		uris /
			\bog/gamengine/demo/atlas/hero.png
			\bog/gamengine/demo/atlas/hero_1.png
			\bog/gamengine/demo/atlas/hero_2.png
			\bog/gamengine/demo/atlas/coin.png
			\bog/gamengine/demo/atlas/wall.png
			\bog/gamengine/demo/atlas/floor.png
		size 64
	Point $bog_gamengine_point
		cam <= Cam
		width <= draw_width
		height <= draw_height
		scale <= draw_dpr
	Sound $bog_gamengine_sound
		uris *
			coin \bog/gamengine/demo/sound/coin.wav
	Clock $bog_gamengine_clock
	Scene $bog_gamengine_scene
		clock <= Clock
		input <= Input
		kids <= nodes /
		phys <= Phys $bog_gamengine_phys
			bodies <= bodies /
			tile <= Tile
	Cam $bog_gamengine_cam_flat
		height 15
		pos <= cam_pos Float32Array
	Tilemap $bog_gamengine_tilemap
		tile <= Tile
		atlas <= Atlas
		palette <= palette *
	Hero $bog_gamengine_demo_flat_hero
		input <= Input
		pos? <=> hero_pos? Float32Array
		face_left? => hero_face_left?
		clip? => hero_clip?
	Hero_sprite $bog_gamengine_sprite
		parent <= Hero
		atlas <= Atlas
		frame \hero
		flip_x <= hero_face_left
		clock <= Clock
		clip <= hero_clip
		fps 6
		clips *
			walk /
				\hero
				\hero_1
				\hero_2
				\hero_1
	Grid $bog_gamengine_nav_grid
		tile <= Tile
	Ghost $bog_gamengine_nav_agent
		grid <= Grid
		target <= hero_pos
		pos? <=> ghost_pos? Float32Array
	Ghost_sprite $bog_gamengine_sprite
		parent <= Ghost
		atlas <= Atlas
		frame \coin
		tint <= ghost_tint Float32Array
	Coin* $bog_gamengine_demo_flat_coin
		sound <= Sound
		pos <= coin_pos* Float32Array
		taken? => coin_taken*?
	Coin_sprite* $bog_gamengine_sprite
		parent <= Coin*
		atlas <= Atlas
		frame \coin
	Font $bog_gamengine_text_font
		size 64
		chars \+1
	Font_atlas $bog_gamengine_atlas
		size 64
		sources <= font_sources /
	Coin_text* $bog_gamengine_text
		font <= Font
		atlas <= Font_atlas
		value \+1
		height 0.4
		align \center
		color <= coin_text_color Float32Array
		pos <= coin_text_pos* Float32Array
